import { ListStatusIcon } from "@components/common/faro-table/bulk-dialog/content-list/list-status-icon";
import { MemberListContent } from "@components/common/faro-table/bulk-dialog/content-list/member-list-content";
import { ProjectListContent } from "@components/common/faro-table/bulk-dialog/content-list/project-list-content";
import { TeamListContent } from "@components/common/faro-table/bulk-dialog/content-list/team-list-content";
import { TableDataType } from "@components/common/faro-table/faro-table-types";
import { NO_TRANSLATE_CLASS, red } from "@flat-ui";
import { ListItem } from "@mui/material";
import { FetchingItem } from "@store/table/table-slice-helper";
import { withEllipsisTwoLines } from "@styles/common-styles";

interface Props {
  /** The type of entity shown in list item */
  tableDataType: TableDataType;

  /** The item itself */
  item: FetchingItem;
}

/** List item in bulk action dialog  */
export function BulkActionListItem({
  tableDataType,
  item,
}: Props): JSX.Element | null {
  let content: JSX.Element | null = null;
  switch (tableDataType) {
    case "projects":
      content = ProjectListContent({ item });
      break;
    case "members":
      content = MemberListContent({ item });
      break;
    case "teams":
      content = TeamListContent({ item });
      break;
    default:
      break;
  }

  // If the entity (project, member, etc.) is not available in the store,
  // it means it has been deleted or is inaccessible and "content" will be null.
  // In that case, we don't render the list item as there is no entity name or
  // details to show in the item row.
  if (!content) {
    return null;
  }

  return (
    <ListItem
      sx={{
        px: "0px",
        fontSize: "14px",
        backgroundColor: item.status === "not-allowed" ? red[100] : "none",
        "& .MuiListItemText-root": {
          ml: "12px",
          ...withEllipsisTwoLines,
          maxWidth: "350px",
        },
      }}
      className={NO_TRANSLATE_CLASS}
      secondaryAction={<ListStatusIcon item={item} />}
    >
      {content}
    </ListItem>
  );
}
